import { colord } from "colord";

import type { Format } from "../color/colorHelpers.ts";
import type { PlayerPalette } from "./types.ts";

export const makePalette = (
  definition: Omit<PlayerPalette, "light" | "dark" | "foreground"> & Partial<PlayerPalette>,
  // ToDo: take color format and store against the Palette so it can be saved and redisplayed in the same format.
  _colorFormat: Format = "rgb",
) => {
  const main = colord(definition.main).isValid() ? definition.main : "#ffffff";

  return {
    main,
    light: definition.light || colord(main).lighten(0.15).toRgbString(),
    dark: definition.dark || colord(main).darken(0.15).toRgbString(),
    foreground: definition.foreground || (colord(main).isLight() ? "#000000" : "#ffffff"),
  };
};
